<template>
  <div class="container-fluid-footer">    
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center col-md-2 pt-5 pb-5">
					<img  src="@/assets/logo_univision 2.png" alt="" width="100%">
				</div>
      </div>
				
      
    </div>
  </div>
</template>
  
  <script>
  
    export default {
      name: 'Footer',
      data () {
        return {
          publicPath: process.env.BASE_URL
        }
      },
      props: {
        article: {}
      }
    }
  
  </script>